import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/organization',
  component: Layout,
  name: 'Organization',
  meta: {
    title: '组织管理',
    icon: 'i-ant-design:team-outlined',
    auth: 'organization',
  },
  children: [
    {
      path: 'user',
      name: 'OrganizationUser',
      component: () => import('@/views/organization/user/index.vue'),
      meta: {
        title: '员工管理',
        icon: 'i-ant-design:user-outlined',
        auth: 'user:list',
      },
    },
    {
      path: 'user/detail/:id',
      name: 'OrganizationUserDetail',
      component: () => import('@/views/organization/user/detail.vue'),
      meta: {
        title: '员工详情',
        auth: 'user:list',
        menu: false,
        activeMenu: '/organization/user',
        tabMerge: 'activeMenu',
      },
    },
    {
      path: 'role',
      name: 'OrganizationRole',
      component: () => import('@/views/organization/role/index.vue'),
      meta: {
        title: '角色管理',
        icon: 'i-ant-design:safety-outlined',
        auth: 'role:list',
      },
    },
    {
      path: 'department',
      name: 'OrganizationDepartment',
      component: () => import('@/views/organization/department/index.vue'),
      meta: {
        title: '部门管理',
        icon: 'i-ant-design:apartment-outlined',
        auth: 'department:list',
      },
    },
  ],
}

export default routes
